import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  token: localStorage.getItem("wwp-token") || "",
  user: {},
  loginAs: {},
  outfitterId: null,
  adminId: localStorage.getItem("wwp-admin-id") || null,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  getUser: (state) => state.user,
  outfitterId: (state) => state.outfitterId,
  adminId: (state) => state.adminId,
};

const actions = {
  set_outfitter_id({ commit }, id) {
    if (id) {
      localStorage.removeItem("wwp-outfitter-id");
      localStorage.setItem("wwp-outfitter-id", id);
      commit("set_outfitter_id", id);
    } else {
      id = localStorage.getItem("wwp-outfitter-id");
      if (id) {
        commit("set_outfitter_id", id);
      }
    }
    return id;
  },
  async reset_lost_password(context, data) {
    return await asyncHandler(
      HTTP({ url: "auth/reset-lost-password", method: "POST", data })
    );
  },
  async validate_lost_password(context, data) {
    return await asyncHandler(
      HTTP({ url: "auth/validate-lost-password", method: "POST", data })
    );
  },
  async lost_password(context, data) {
    return await asyncHandler(
      HTTP({ url: "auth/lost-password", method: "POST", data })
    );
  },

  async login_as_back({ commit, state }) {
    if (!state.adminId) {
      return;
    }
    const resp = await asyncHandler(
      HTTP({ url: "auth/login-as/" + state.adminId, method: "GET" })
    );
    commit("clear_admin_id");
    if (resp.success) {
      commit("logout");
      localStorage.removeItem("wwp-token");
      delete HTTP.defaults.headers.common["Authorization"];

      localStorage.setItem("wwp-token", resp.token);
      commit("set_token", resp.token);
      commit("set_user", resp.user);
      if (resp.user.outfitter_id) {
        localStorage.removeItem("wwp-outfitter-id");
        localStorage.setItem("wwp-outfitter-id", resp.user.outfitter_id);
        commit("set_outfitter_id", resp.user.outfitter_id);
      }
    }
    return resp;
  },

  async login_as({ commit }, id) {
    commit("set_admin_id");

    const resp = await asyncHandler(
      HTTP({ url: "auth/login-as/" + id, method: "GET" })
    );
    if (resp.success) {
      commit("logout");
      localStorage.removeItem("wwp-token");
      delete HTTP.defaults.headers.common["Authorization"];

      localStorage.setItem("wwp-token", resp.token);
      commit("set_token", resp.token);
      commit("set_user", resp.user);
      if (resp.user.outfitter_id) {
        localStorage.removeItem("wwp-outfitter-id");
        localStorage.setItem("wwp-outfitter-id", resp.user.outfitter_id);
        commit("set_outfitter_id", resp.user.outfitter_id);
      }
    }
    return resp;
  },

  async login({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "auth/login", method: "POST", data })
    );
    if (resp.success) {
      localStorage.setItem("wwp-token", resp.token);
      commit("set_token", resp.token);
      commit("set_user", resp.user);
      if (resp.user.outfitter_id) {
        localStorage.removeItem("wwp-outfitter-id");
        localStorage.setItem("wwp-outfitter-id", resp.user.outfitter_id);
        commit("set_outfitter_id", resp.user.outfitter_id);
      }
    }
    return resp;
  },

  async logout({ commit }) {
    commit("logout");
    localStorage.removeItem("wwp-token");
    delete HTTP.defaults.headers.common["Authorization"];
  },

  async get_user({ commit, state }) {
    if (state.user.id) return;
    let token = localStorage.getItem("wwp-token");
    if (token) {
      commit("set_token", token);
      const resp = await asyncHandler(HTTP({ url: "user/get", method: "GET" }));
      if (resp.success) {
        commit("set_user", resp.user);
      }
      return resp;
    }
  },
};

const mutations = {
  clear_admin_id: (state) => {
    state.adminId = null;
    localStorage.removeItem("wwp-admin-id");
  },
  set_admin_id: (state) => {
    state.adminUserId = state.user.id;
    localStorage.setItem("wwp-admin-id", state.user.id);
  },
  set_outfitter_id: (state, id) => {
    state.outfitterId = id;
  },
  set_token: (state, token) => {
    state.token = token;
  },
  logout: (state) => {
    state.token = "";
    state.user = {};
  },
  set_user: (state, user) => {
    state.user = user;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
